import { render, staticRenderFns } from "./Similar.vue?vue&type=template&id=2c814d26&scoped=true"
import script from "./Similar.vue?vue&type=script&lang=js"
export * from "./Similar.vue?vue&type=script&lang=js"
import style0 from "./Similar.vue?vue&type=style&index=0&id=2c814d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c814d26",
  null
  
)

export default component.exports